module.exports = __webpack_public_path__ + "img/14_19.a47a7ebe.png";